import * as R from 'ramda'

import { base as baseConfig } from '@/config'

export const API_QUERY_KEY = 'API'

export const TOKEN_HEADER_KEY = 'X-Access-Token'
export const DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Frontend-Path': `${window.location.pathname}${window.location.search}`,
  'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
}

export enum CLIENT_METHODS {
  POST = 'post',
  GET = 'get',
  PATCH = 'patch',
  PUT = 'put',
}

export const RESOURCES = {
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  SEND_RESET_PASSWORD_EMAIL: 'SEND_RESET_PASSWORD_EMAIL',
  RESET_PASSWORD: 'RESET_PASSWORD',
  VALIDATE_EMAIL: 'VALIDATE_EMAIL',
  VALIDATE_EMAIL_INVITE: 'VALIDATE_EMAIL_INVITE',
  LOGOUT: 'LOGOUT',
  RESEND_CODE: 'RESEND_CODE',
  MFA: 'MFA',
}

const staticEndpoint = R.always

export const RESOURCE_ENDPOINTS = {
  [RESOURCES.LOGIN]: staticEndpoint(`${baseConfig.apiServiceUrl}/api/v1/members/login`),
  [RESOURCES.SEND_RESET_PASSWORD_EMAIL]: staticEndpoint(
    `${baseConfig.apiServiceUrl}/api/v1/members/send-reset-password-email`
  ),
  [RESOURCES.RESET_PASSWORD]: staticEndpoint(`${baseConfig.apiIdpServiceUrl}/api/v1/auth/resetPassword`),
  [RESOURCES.REGISTER]: staticEndpoint(`${baseConfig.apiServiceUrl}/api/v1/members/register`),
  [RESOURCES.VALIDATE_EMAIL]: staticEndpoint(`${baseConfig.apiServiceUrl}/api/v1/members/validate-email`),
  [RESOURCES.VALIDATE_EMAIL_INVITE]: staticEndpoint(`${baseConfig.apiServiceUrl}/api/v1/members/validate-email-invite`),
  [RESOURCES.LOGOUT]: staticEndpoint(`${baseConfig.apiIdpServiceUrl}/api/v1/sessions/logout`),
  [RESOURCES.MFA]: staticEndpoint(`${baseConfig.apiIdpServiceUrl}/api/v1/auth/verify-mfa`),
  [RESOURCES.RESEND_CODE]: staticEndpoint(`${baseConfig.apiServiceUrl}/api/v1/members/resend-mfa`),
}

export const RESPONSE_MESSAGES = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

export interface CustomRequestHeaders {}

type JSONPrimitive = string | number | boolean | null | undefined

export type JSONValue =
  | JSONPrimitive
  | JSONValue[]
  | {
      [key: string]: JSONValue
    }

export interface ResponseData {
  data: JSONValue
  message: string
}

/**
 * Curated list of timezones offered to members at signup.
 * Mirrors the list used for company settings in the app frontend
 * (frontend/src/data/api/constants.ts) — keep them in sync.
 */
export const timezones: Array<{ value: string; label: string }> = [
  { value: 'Pacific/Honolulu', label: 'Hawaii-Aleutian Time – Honolulu' },
  { value: 'America/Anchorage', label: 'Alaska Time – Anchorage' },
  { value: 'America/Los_Angeles', label: 'Pacific Time – Los Angeles' },
  { value: 'America/Denver', label: 'Mountain Time – Denver' },
  { value: 'America/Chicago', label: 'Central Time – Chicago' },
  { value: 'America/New_York', label: 'Eastern Time – New York' },
]
